<template>
  <div class="box">
    <arrorImg bg="white"></arrorImg>
    <navBar title="充值中心" color="#ffffff" @returnCharge="returnCharge"></navBar>
    <div class="container_box">
      <uniActivity ref="child" :showSetting="1" :pagetype="pageType" :bookId="payItem.bookId"
        :chapterId="payItem.chapterId"></uniActivity>
      <div class="content">
        <span v-if="payItem.bookId == 0&&priceType!=3" class="charge-title">当前余额
          <span class="charge-title-active"> {{ currency }} </span> 书币</span>
          <span  class="charge-title" v-if="priceType==3">后续内容为会员专享，开通可畅读全站小说</span>
        <div v-if="payItem.bookId!= 0&&priceType!=3" class="arrears-info">
          <span class="charge-title" v-if="payItem.chapterId"> 本章需 </span>
          <span class="charge-title" v-else> 整本需 </span>
          <span class="charge-title-active">{{ needCurrency }}</span><span class="charge-title"> 书币，余额 </span>
          <span class="charge-title-active">{{ currency }} </span>
          <span class="charge-title">书币,请充值</span>
        </div>
        <div>
          <span class="charge-choose">选择充值金额</span>
          <div class="charge-list">
            <div class="chargr-list-item" @click="selectList(item)" v-for="(item, index) in setList" :key="index"
              :style="{ marginRight: index % 2 == 0 ? '1rem' : '' }" :class="selectId == item.id ? 'select-item' : ''">
              <span class="charge-amount">{{ item.amount / 100 }}元</span>
              <span class="charge-currency" v-if="item.type === 0">{{ item.amount }}书币<span
                  v-if="item.itemDetail.giveCurrency > 0">+送{{ item.itemDetail.giveCurrency }}书币</span></span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 5">全站小说免费看1天</span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 6">全站小说免费看3天</span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 0">全站小说免费看7天</span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 1">全站小说免费看31天</span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 2">全站小说免费看90天</span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 3">全站小说免费看180天</span>
              <span class="charge-currency" v-if="item.type == 1 && item.itemDetail.vipType == 4">全站小说免费看365天</span>
              <span class="give-currency" v-if="
                (item.itemDetail.giveCurrency > 0 && item.type == 0) ||
                item.type == 1
              ">
                <span v-if="item.type == 0">
                  送{{ item.itemDetail.giveCurrency / 100 }}元</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 5">1天会员</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 6">3天会员</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 0">一周会员</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 1">包月会员</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 2">季度会员</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 3">半年会员</span>
                <span v-if="item.type == 1 && item.itemDetail.vipType == 4">包年会员</span>
              </span>
              <!-- <span
                class="give-currency"
                v-if="
                  (item.giveCurrency > 0 && item.isVip == 0) || item.isVip == 1
                "
                >{{
                  item.isVip == 1
                    ? "包年看书"
                    : "送" + item.giveCurrency / 100 + "元"
                }}</span>-->
              <span class="icon-star" v-if="item.cornerMark">
                {{ item.cornerMark }}
              </span>
            </div>
          </div>
        </div>
        <!-- 优惠券 -->
        <div class="conpon-contaner" style="width: 100%" v-if="CouponStatus == 0">
          <div class="conpon-box" @click="routeChoose">
            <div class="conpon-left">
              <img src="../../../static/couponIcon.png" alt="" />
              <span>满{{ couponItem.fullMoney }}减{{
                couponItem.reduceMoney
              }}</span>
            </div>
            <div class="conpon-right">
              <span>-{{ couponItem.reduceMoney }}</span>
              <img src="../../../static/read-arrow.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 优惠券 -->
        <div style="width: 100%; margin-bottom: 12px" v-if="CouponStatus == 1">
          <div class="conpon-box" @click="routeChoose">
            <div class="conpon-left">
              <img src="../../../static/couponIcon.png" alt="" />
              <span>优惠券</span>
            </div>
            <div class="conpon-right">
              <span>差{{ differenceMoney }}元可使用优惠券</span>
              <img src="../../../static/read-arrow.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 优惠券 -->
        <div style="width: 100%; margin-bottom: 12px" v-if="CouponStatus == 2 || CouponStatus == 3">
          <div class="conpon-box" @click="routeChoose">
            <div class="conpon-left">
              <img src="../../../static/couponIcon.png" alt="" />
              <span>优惠券</span>
            </div>
            <div class="conpon-right">
              <span style="color: #aaaaaa">{{
                CouponStatus == 2 ? "不使用优惠券" : "无可用优惠券"
              }}</span>
              <img src="../../../static/gray-arrow.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="notice-tips">
        <span>温馨提示</span>
        <span>1. 书币充值比例：1元=100书币</span>
        <span>2. 书币充值一经购买不支持退货，请悉知</span>
        <span>3. 未满18周岁的未成年人应在法定监护人同意下进行充值</span>
        <span>4. 赠送书币有效期为{{
          dictValue
        }}天，过期自动失效，阅读时优先扣除赠送书币</span>
        <span>5. VIP会员尊享该应用内全场免费阅读的权益，充值购买时间可累加</span>
     
        <span>6. 主动支付即表示您已阅读并同意
          <span style="color: #de3b34" @click="routeAgreement">《用户协议》</span>、<span style="color: #de3b34"
            @click="routeFeed">《隐私政策》</span></span>
            <span>7. 如遇充值问题，请在公众号内点击联系客服菜单获取帮助
        </span>
      </div>
      <div class="bottom-code" v-if="CsQrCodeUrl">
      <div>
          <div>
            <img :src="CsQrCodeUrl" alt="">
          </div>
         <p>如遇充值问题，可长按上方二维码</p>
         <p>添加人工客服，立即处理问题</p>
      </div>

    </div>
    </div>
    <div class="pay_img" v-if="agentPaySwitch == 1">
      <div class="custom_btn" @click="gotoCustompay">
        <img src="../../../static/agency-icon.png" alt="" />
        <span>找人付</span>
      </div>
      <div class="right_btn" @click="goPay">
        <span>立即支付:
          {{ (payItem.money - payItem.couponMoney * 100) / 100 }}元</span>
        <span v-if="payItem.couponMoney != 0">(已优惠￥{{ payItem.couponMoney }})</span>
      </div>
    </div>
    <div class="pay-btn" v-else @click="goPay">
      <span>立即支付:
        {{ (payItem.money - payItem.couponMoney * 100) / 100 }}元</span>
      <span v-if="payItem.couponMoney != 0">(已优惠￥{{ payItem.couponMoney }})</span>
    </div>
    <div class="mask_div" v-if="showTask">
      <div>
        <img src="../../../static/mask-task.png" alt="" />
        <span class="mask_can" @click="routeTask"></span>
        <span class="mask_close" @click="backRoute"></span>
      </div>
    </div>
    <uniPopactivity ref="popChild" :pagetype="1" :tabbarIndex="1" :type="pageType" :bookIds="payItem.bookId"
      :chapterId="payItem.chapterId"></uniPopactivity>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import uniActivity from "../components/activity-swiper.vue";
import uniPopactivity from "../components/pop-activity.vue";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name: "bookCharge",
  components: {
    uniActivity,
    uniPopactivity,
    arrorImg,
    navBar,
  },
  data() {
    return {
      currency: 0,
      setList: [],
      selectId: 0,
      payItem: {
        settingType:'',
        settingsId: 0,
        money: 0, // 单位:分
        bookId: "", //书籍ID
        chapterId: "", //章节id
        vipId: 0, //Vip活动ID
        activityId: 0, //活动编号 ，会员和充值默认为0
        couponMoney: 0,
        couponId: 0,
        payType: 2,
      },
      couponId: 0,
      needCurrency: 0,
      pageType: "",
      out_trade_no: 0, //订单号
      showTask: false,
      isTask: false,
      CouponStatus: -1, //0:满减优惠券，1：差多少可使用优惠券 2：不使用优惠券 3：支付提交时优惠券过期如果没有优惠券提示暂无可用优惠券
      receiveCoupons: [],
      couponItem: {},
      differenceMoney: 0, //差多少可使用优惠券
      isReload: false, //是否是从选择优惠券页返回
      isEntranceData: "",
      messageType: "",
      clickMessId: 0,
      channelRecordId: 0,
      promotionCode: "",
      isChargePay: false, //活动页充值是否成功返回
      dictValue: 0,
      agentPaySwitch: 0,
      CsQrCodeUrl:'',
      priceType:''
    };
  },
  mounted() {
    var that = this;
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        // ios 有效, android 和 pc 每次都是 false
        that.init()
      } else {
        console.log("refresh");
        // ios 除外
        if (sessionStorage.getItem("refresh") === "true") {
          // location.reload();
          that.getUserCurrency();
        }
      }
      sessionStorage.removeItem("refresh");
    });
    console.log("refresh");
  },
  activated() {
    this.init();

  },
  destroyed() { },
  beforeRouteEnter(to, from, next) {
    if (from.name == "chooseCoupons" && to.name == "bookCharge") {
      // 当从上个页面chooseCoupons返回当前页面时，不刷新当前页面
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    } else {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    }
    console.log(from);
    console.log(to);
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.$base.setStorage("orderNum", this.out_trade_no);
    console.log("离开页面之前");
    // this.returnCharge()
    next();
  },
  methods: {
    getCsQrCodeUrl(){
      this.$api.getCsQrCodeUrl().then((res) => {
             if(res.status==1){
              this.CsQrCodeUrl=res.data
             }
      })
    },
    getOrderStatus() {
      var params = {
        orderNo: this.$base.getStorage("orderNum"),
        currentPageType: 2,
      };
      this.$api.getOrderStatus(params).then((res) => {
        this.$base.removeStorage("isActivity");
        this.$base.removeStorage("orderNum");
        if (res.status == 1) {
          Toast({
            message: res.message,
          });
        }
      });
    },
    init() {
      this.payItem.bookId = this.$route.query.bookId ? this.$route.query.bookId : ''
      this.payItem.chapterId = this.$route.query.chapterId ? this.$route.query.chapterId : ''
      this.needCurrency = this.$route.query.needCurrency ? this.$route.query.needCurrency : '';
      this.priceType = this.$route.query.priceType ? this.$route.query.priceType : '';
      // priceType
      this.currency = this.$base.getStorage("currency");
      if (!this.$route.meta.isBack) {
        this.CouponStatus = -1;
        this.pageType = this.$route.query.pageType;
        if (this.$route.query.couponId) {
          this.couponId = this.$route.query.couponId;
        } else {
          this.couponId = ''
        }
        if (this.$route.query.isEntranceData) {
          this.isEntranceData = this.$route.query.isEntranceData;
        } else {
          this.isEntranceData = ''
        }
        var openid = this.$base.getStorage("openid");
        var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
        var city = this.$base.getStorage("city");
        if (!openid) {
          //静默登录手动登录
        } else if (isWxAuthorized == 0 && city == 1 && openid && !this.$store.state.user.isSNS) {
          this.$base.setStorage("isSNS", true);
          this.$store.state.user.isSNS = true;
          this.$commonApi.snsapiUserinfo();
          this.getRechargeSettings();
        } else {
          this.getRechargeSettings();
        }
      } else {
        // 如果isBack是true，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
        // this.CouponStatus = this.$base.getStorage("couponStatus");
        if (this.$base.getStorage("couponStatus")) {
          this.CouponStatus = this.$base.getStorage("couponStatus");
          if (this.CouponStatus != 2) {
            this.payItem.couponId = this.$base.getStorage("couponId");
            this.usersReceiveCoupons(true);
          } else {
            this.payItem.couponId = 0;
            this.payItem.couponMoney = 0;
          }
        } else {
          this.usersReceiveCoupons(false);
        }
        console.log(this.CouponStatus);
      }
      this.$commonApi.share();
      setTimeout(() => {
        this.getUserCurrency();
      }, 500);

    },
    getOutReaderSwitckIsOpen() {
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
          this.agentPaySwitch = res.data.agentPaySwitch;
        }
      });
    },
    returnCharge() {
      this.getRechargeBackIsTips();
    },
    getCurrencyValidity() {
      this.$api.getCurrencyValidity().then((res) => {
        if (res.status == 1) {
          this.dictValue = res.data.chargeCurrency.dictValue;
        }
      });
    },
    routeChoose() {
      if (this.CouponStatus != 3) {
        this.$base.setStorage("couponStatus", "");
        this.$router.push({
          path: "/pages/chooseCoupons/index",
          query: {
            chargeMoney: this.payItem.money,
            couponId: 0,
            CouponStatus: this.CouponStatus,
            pageType: "bookCharge",
          },
        });
      }
    },
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType == "bookMine") {
        pageType = "我的";
      } else if (this.pageType == "bookRead") {
        pageType = "阅读器";
      } else if (this.pageType == "bookTask") {
        pageType = "任务中心";
      } else if (this.pageType == "bookCurrency") {
        pageType = "书币";
      } else if (this.pageType == "bookCity") {
        pageType = "书城";
      }
      var params = {
        pageName: "充值中心",
        pageRemark: "上级页面：" + pageType,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => { });
    },
    backRoute() {
      this.showTask = false;
      this.$router.go(-1);
    },
    routeTask() {
      this.showTask = false;
      this.$router.push({
        path: "/pages/bookTaskone/index",
        query: {
          pageType: "bookCharge",
        },
      });
    },
    getRechargeBackIsTips() {
      this.$api.getRechargeBackIsTips().then((res) => {
        if (res.status == 1 && res.data == "0" && !this.isTask) {
          this.showTask = true;
        } else {
          this.$router.go(-1);
        }
      });
    },
    getRechargeSettings() {
      this.$api.getRechargeSettings().then((res) => {
        if (res.status == 1) {
          this.setList = res.data;
          if (res.data.length > 0) {
            this.payItem.settingsId = res.data[0].id;
            this.payItem.settingType = res.data[0].settingType;
            this.payItem.money = res.data[0].amount;
            this.selectId = res.data[0].id;
          }
          this.setList.forEach((item) => {
            if (item.defaults === 0) {
              this.selectId = item.id;
              this.payItem.settingsId = item.id;
              this.payItem.settingType = item.settingType;
              this.payItem.money = item.amount;
            }
          });
          this.usersReceiveCoupons(false);
          this.getCurrencyValidity();
          this.getOutReaderSwitckIsOpen();
         this.getCsQrCodeUrl();
          this.insertPageAccessData();
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
          this.$refs.child.findRechargeActivity();
          this.$refs.popChild.getPopup();
        }
      });
    },
    selectList(item) {
      this.selectId = item.id;
      this.payItem.settingType = item.settingType;
      this.payItem.settingsId = item.id;
      this.payItem.money = item.amount;
      this.payItem.couponId = 0;
      this.payItem.couponMoney = 0;
      this.usersReceiveCoupons(true);
    },
    usersReceiveCoupons(flag) {
      var params = {
        isRechargePage: 0,
      };
      this.$api.usersReceiveCoupons(params).then((res) => {
        if (res.status === 1) {
          console.log("couponSt" + this.CouponStatus);
          this.receiveCoupons = res.data.couponReturnDTO;
          if (!flag) {
            if (this.couponId) {
              this.receiveCoupons.forEach((item) => {
                if (item.id == this.couponId) {
                  if (this.payItem.money / 100 >= item.fullMoney) {
                    this.couponItem = item;
                    this.CouponStatus = 0;
                    this.payItem.couponMoney = item.reduceMoney;
                    this.payItem.couponId = this.couponId;
                  } else {
                    this.differenceMoney =
                      (item.fullMoney * 100 - this.payItem.money) / 100;
                    this.CouponStatus = 1;
                    this.payItem.couponMoney = 0;
                    this.payItem.couponId = 0;
                  }
                }
              });
            } else {
              if (this.CouponStatus == -1 && this.receiveCoupons.length != 0) {
                var id = this.$base.choicelessCoupons(
                  this.receiveCoupons,
                  this.payItem.money
                );
                var idrgreater = this.$base.choicegreaterCoupons(
                  this.receiveCoupons,
                  this.payItem.money
                );
                console.log(id);
                if (id != 0) {
                  this.payItem.couponId = id;
                  this.CouponStatus = 0;
                  this.receiveCoupons.forEach((item) => {
                    if (item.id == this.payItem.couponId) {
                      this.couponItem = item;
                      this.payItem.couponMoney = item.reduceMoney;
                    }
                  });
                } else if (idrgreater != 0) {
                  this.payItem.couponId = 0;
                  this.CouponStatus = 1;
                  this.payItem.couponMoney = 0;
                  this.receiveCoupons.forEach((item) => {
                    if (item.id == idrgreater) {
                      this.differenceMoney =
                        (item.fullMoney * 100 - this.payItem.money) / 100;
                    }
                  });
                }
              }
            }
          } else {
            if (this.payItem.couponId) {
              this.receiveCoupons.forEach((item) => {
                if (item.id == this.payItem.couponId) {
                  if (this.payItem.money / 100 >= item.fullMoney) {
                    this.couponItem = item;
                    this.CouponStatus = 0;
                    this.payItem.couponMoney = item.reduceMoney;
                  } else {
                    this.differenceMoney =
                      (item.fullMoney * 100 - this.payItem.money) / 100;
                    this.CouponStatus = 1;
                    this.payItem.couponMoney = 0;
                    this.payItem.couponId = 0;
                  }
                }
              });
            } else {
              var id = this.$base.choicelessCoupons(
                this.receiveCoupons,
                this.payItem.money
              );
              var idrgreater = this.$base.choicegreaterCoupons(
                this.receiveCoupons,
                this.payItem.money
              );
              console.log("id" + id);
              if (id != 0) {
                this.payItem.couponId = id;
                this.CouponStatus = 0;
                this.receiveCoupons.forEach((item) => {
                  if (item.id == this.payItem.couponId) {
                    this.couponItem = item;
                    console.log(this.couponItem);
                    this.payItem.couponMoney = item.reduceMoney;
                  }
                });
              } else if (idrgreater != 0) {
                this.payItem.couponId = 0;
                this.CouponStatus = 1;
                this.payItem.couponMoney = 0;
                this.receiveCoupons.forEach((item) => {
                  if (item.id == idrgreater) {
                    this.differenceMoney =
                      (item.fullMoney * 100 - this.payItem.money) / 100;
                  }
                });
              } else if (flag == 3 && this.receiveCoupons.length == 0) {
                this.CouponStatus = 3;
                this.payItem.couponId = 0;
              }
            }
          }
          console.log("rrrrr" + this.differenceMoney);
          console.log(this.couponItem);
          console.log(this.payItem);
          console.log(this.CouponStatus);
        }
      });
    },
    routeFeed() {
      this.$router.push({
        path: "/pages/Privacy/index",
        query: {
          pageType: "bookCharge",
        },
      });
    },
    routeAgreement(){
      this.$router.push({
        path: "/pages/agreement/index",
        query: {
          pageType: "bookCharge",
        },
      });
    },
    goPay() {
      this.payItem.payType = 2;
      this.$api.separateWxpay(this.payItem).then((res) => {
        if (res.status == 1) {
          console.log(res.data.orderNo);
          this.out_trade_no = res.data.orderNo;
          // h5公众号微信支付
          // #ifdef H5
          var data = res.data;
          var pageType = "";
          if (this.pageType == "bookRead") {
            pageType = "bookRead";
          } else {
            pageType = "bookCharge";
          }
          // if (this.pageType == "bookRead") {
          this.$base.setStorage("orderNum", this.out_trade_no);
          this.$base.setStorage("isActivity", 1);
          // }
          var url_config = window.location.origin + "/";
          var WXurl = this.$commonApi.PayURL(); //环境
          var URL =
            WXurl +
            "/payIndex.html?pageType=" +
            pageType +
            "&type=bookCharge&orderNo=" +
            this.out_trade_no +
            "&officialCode=" +
            data.officialCode +
            "&openid=" +
            this.$base.getStorage("openid") +
            "&configUrl=" +
            url_config;
          window.location.href = URL;
        } else if (res.status == 3) {
          this.payItem.couponId = 0;
          this.payItem.couponMoney = 0;
          this.usersReceiveCoupons(3);
        } else {
          console.log(res.message);
          Toast({
            message: res.message,
          });
        }
      });
    },
    gotoCustompay() {
      //找人代付
      this.payItem.payType = 3;
      this.$api.separateWxpay(this.payItem).then((res) => {
        if (res.status == 1) {
          console.log(res.data.orderNo);
          this.out_trade_no = res.data.orderNo;
          // h5公众号微信支付
          // #ifdef H5
          var data = res.data;
          var pageType = "pageCustom";
          this.$router.push({
            path: "/pages/bookFindpay/index",
            query: {
              pageType: "pageCustom",
              orderNo: this.out_trade_no,
              needMoney:
                (this.payItem.money - this.payItem.couponMoney * 100) / 100,
              officialCode: res.data.officialCode,
            },
          });
        } else if (res.status == 3) {
          this.payItem.couponId = 0;
          this.payItem.couponMoney = 0;
          this.usersReceiveCoupons(3);
        } else {
          Toast({
            message: res.data.message,
          });
        }
      });
    },
    getUserCurrency() {
      this.$api.getUserCurrency().then((res) => {
        if (res.status == 1) {
          this.currency = res.data;
          this.$base.setStorage("currency", res.data);
          var isActivity = this.$base.getStorage("isActivity");
          if (isActivity == 1 && this.$base.getStorage("orderNum")) {
            //订单支付成功
            this.getOrderStatus();
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.container_box {
  padding-top: calc(44px + env(safe-area-inset-top));
  margin-bottom: 60px;
  padding-bottom: 40px;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  /* padding-bottom: 20px+constant(safe-area-inset-bottom); */
  /* 兼容 iOS < 11.2 */
  /* padding-bottom: 20px+env(safe-area-inset-bottom); */
}

.conpon-box {
  background-color: #f7f7f7;
  border-radius: 8px;
  justify-content: space-between;
  padding: 12px;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.conpon-box>div {
  align-items: center;
  display: flex;
}

.conpon-left>img {
  width: 16px;
  height: 16px;
}

.conpon-left>span {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  margin-left: 8px;
}

.conpon-contaner {
  margin-bottom: 20px;
  margin-top: -4px;
}

.conpon-right>img {
  width: 6px;
  height: 12px;
}

.conpon-right>span {
  font-size: 14px;
  color: #de3b34;
  margin-right: 8px;
}

.box {
  padding: 0px 16px;
}

.content {
  margin-top: 20px;
}

.charge-title {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 16px;
}

.charge-title-active {
  color: #de3b34;
  font-weight: bold;
  font-size: 16px;
}

.charge-choose {
  font-size: 16px;
  color: #333333;
  display: block;
  font-weight: bold;
  /* margin-bottom: 16px; */
}

.charge-choose-active {
  font-size: 12px;
  color: #888888;
  font-weight: normal;
  margin-left: 8px;
}

.charge-list {
  overflow: hidden;
  padding-top: 16px;
}

.chargr-list-item {
  float: left;
  border: 1px solid #d7d7d7;
  /* width: 47%; */
  width: 156px;
  border-radius: 8px;
  position: relative;
  padding: 12px;
  padding-right: 3px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.charge-list>div.select-item {
  /* padding-right: 3px; */
  border: 2px solid #de3b34;
  background-color: rgba(222, 59, 52, 0.05);
  padding: 11px 11px;
  padding-right: 3px;
}

.charge-list>div>span {
  display: block;
}

.charge-amount {
  font-size: 20px;
  color: #333333;
  margin-bottom: 5px;
}

.charge-currency {
  font-size: 12px;
  color: #888888;
  display: block;
}

.give-currency {
  background: #de3b34;
  border-radius: 8px 0 0 8px;
  width: 59px;
  height: 19px;
  line-height: 19px;
  font-size: 12px;
  color: #ffffff;
  position: absolute;
  right: 0px;
  top: 12px;
  text-align: center;
}

.icon-star {
  position: absolute;
  left: 23px;
  top: -9px;
  background: url(../../../static/Rectangle.png) no-repeat;
  background-size: contain;
  width: 58px;
  height: 18px;
  display: block;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
}

.notice-tips {
  font-size: 12px;
  color: #888888;
}

.notice-tips>span {
  margin-bottom: 6px;
  display: block;
  line-height: 17px;
}

.pay_img {
  position: fixed;
  bottom: 0px;
  color: #ffffff;
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  left: 0;
  display: flex;
}

.pay_img>.custom_btn {
  width: 126px;
  background-color: #f8f8f8;
  font-size: 16px;
  color: #333333;
  display: flex;
  justify-content: center;
}

.pay_img>.custom_btn img {
  widows: 22px;
  height: 22px;
  margin-top: 12px;
  margin-right: 5px;
}

.pay_img>.right_btn {
  width: 234px;
  background-color: #de3b34;
  color: #ffffff;
  height: 44px;
  text-align: center;
  line-height: 44px;
}

.pay-btn {
  position: fixed;
  bottom: 0px;
  background-color: #de3b34;
  color: #ffffff;
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  left: 0;
}

.pay-btn>span:nth-child(1) {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 20px;
}

.pay-btn>span:nth-child(2) {
  font-size: 12px;
  letter-spacing: 0;
}

.mask_div {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0px;
  align-items: center;
  justify-content: center;
}

.mask_div>div {
  width: 292px;
  height: 330px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.mask_div img {
  width: 292px;
  height: 330px;
  display: block;
}

.mask_can {
  width: 200px;
  height: 40px;
  position: absolute;
  left: 46px;
  bottom: 97px;
}

.mask_close {
  width: 200px;
  height: 25px;
  bottom: 64px;
  position: absolute;
  left: 46px;
}
.bottom-code{
  margin-top: 20px;
  /* padding: 20px 16px; */
}
.bottom-code>div{
  width: 328px;
height: 212px;
background: #E0F2FF;
border-radius: 10px;
text-align: center;
padding:20px 0px;
box-sizing: border-box;

}
.bottom-code>div>div{
  width: 128px;
height: 128px;
background: #FDFDFD;
box-shadow: 0px 2px 4px 0px rgba(98,98,98,0.5);
border-radius: 8px;margin:0 auto;
margin-bottom:10px;
}
.bottom-code>div>div img{
  width: 108px;
  height: 108px;
  margin-top: 10px;
}
.bottom-code>div>p{
  font-size: 12px;
color: #868383;
}
</style>



// WEBPACK FOOTER //
// src/view/bookCharge/index.vue